import { render } from "./EditorElement.vue?vue&type=template&id=3e6a9210"
import script from "./EditorElement.vue?vue&type=script&lang=js"
export * from "./EditorElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__